<template lang="pug">
  v-slide-y-transition(mode="out-in")
    v-container(fluid v-if="!isLoading()")
      v-form(ref="invoiceForm", @submit="handleSubmit()")
        v-card(class="mb-2")
          v-card-title
            h3.headline Cliente

          v-card-text
            v-toolbar.mb-3(color="primary", dark)
              v-autocomplete.mt-7(:label="$t('Cliente')", return-object, @input="updateUserData()", v-model="invoice.company.user", :rules="validation.required", :items="users", item-text="showName", required)
              v-btn(text, class="right", @click="updateUserData()") Actualizar

            v-row(wrap)
              v-col(xs12 sm6)
                v-text-field(:label="$t('Nombre comercial')", v-model="invoice.company.name", required)
              v-col(xs12 sm3)
                v-text-field(:label="$t('Nombre fiscal')", v-model="invoice.company.fiscalName")
              v-col(xs12 sm3)
                v-text-field(:label="$t('NIF/CIF/VAT')", v-model="invoice.company.vat")
              v-col(xs12 sm6)
                v-text-field(:label="$t('Nº cuenta contable')", v-model="invoice.company.accountingAccount")
              v-col(xs12 sm6)
                v-text-field(:label="$t('Teléfono')", v-model="invoice.company.phone")
            v-text-field(:label="$t('Dirección')", v-model="invoice.company.address")

            v-row(wrap)
              v-col(xs12 sm6 md4)
                v-text-field(:label="$t('Ciudad')", v-model="invoice.company.town")
              v-col(xs12 sm6 md3)
                v-text-field(:label="$t('Provincia')", v-model="invoice.company.state")
              v-col(xs12 sm4 md2)
                v-text-field(:label="$t('Código Postal')", v-model="invoice.company.zip")
              v-col(xs12 sm8 md3)
                v-autocomplete(:label="$t('Pais')", v-model="invoice.company.country", :items="countries", item-text="name", item-value="code")

            v-text-field(:label="$t('Cliente final')", v-model="invoice.finalCustomer", hint="Solo para agencias", persistent-hint)

          v-card-title
            h3.headline Impuestos y comisiones
          v-card-text
            v-row(wrap)
              v-col(xs12 sm6)
                v-text-field(:label="$t('IVA')", @input="handleTaxesChange()", v-model="invoice.tax")
              v-col(xs12 sm6)
                v-text-field(:label="$t('Comisión')", @input="handleTaxesChange()", v-model="invoice.commission")
              v-col(xs12)
                v-checkbox(:label="$t('IVA incluido')", @change="handleTaxesChange()", v-model="invoice.includedTax")

          v-card-title
            h3.headline Detalles
              v-btn.ml-3(text, color="primary", @click="addDetail()") Añadir detalle

          <!--- CONTINUE FROM HERE DANI --->
          v-card-text
            v-data-table.elevation-1(
              :headers="invoice.serie === 'FM' ? manualDetailsTableHeaders : detailsTableHeaders",
              :items="invoice.details",
              hide-default-footer,
              disable-pagination,
            )
              template(v-slot:item.description="{item}")
                v-edit-dialog(:return-value.sync="item.description", lazy) {{item.description}}
                  v-text-field(style="width: 500px", slot="input", v-model="item.description", label="Descripción", single-line) {{item.price}}
              template(v-slot:item.fromDate="{item}")
                span(v-if="invoice.serie !== 'FM'") {{formatDate(item.fromDate)}}
              template(v-slot:item.toDate="{item}")
                span(v-if="invoice.serie !== 'FM'") {{formatDate(item.toDate)}}
              template(v-slot:item.price="{item}")
                v-edit-dialog(:return-value.sync="item.price", lazy) {{item.price}}
                  v-text-field(slot="input", @input="handleDetailChange()", v-model="item.price", label="Precio", single-line) {{item.price}}
              template(v-slot:item.quantity="{item}")
                v-edit-dialog(:return-value.sync="item.quantity", lazy) {{item.quantity}}
                  v-text-field(slot="input", v-model="item.quantity", @input="handleDetailChange()", label="Unidades", single-line)

              template(slot="items" slot-scope="props")
                //td(v-if="invoice.serie !== 'FM'") {{item.reference}}
                //td
                //  v-edit-dialog(:return-value.sync="props.item.description", lazy) {{props.item.description}}
                //    v-text-field(style="width: 500px", slot="input", v-model="props.item.description", label="Descripción", single-line) {{props.item.price}}
                //td(v-if="invoice.serie !== 'FM'")
                //td(v-if="invoice.serie !== 'FM'") {{formatDate(props.item.toDate)}}
                td(style="text-align: right; width: 120px")
                  v-edit-dialog(:return-value.sync="props.item.price", lazy) {{props.item.price}}
                    v-text-field(slot="input", @input="handleDetailChange()", v-model="props.item.price", label="Precio", single-line) {{props.item.price}}
                td(style="text-align: center; width: 30px;")
                  v-edit-dialog(:return-value.sync="props.item.quantity", lazy) {{props.item.quantity}}
                    v-text-field(slot="input", v-model="props.item.quantity", @input="handleDetailChange()", label="Unidades", single-line)
                td(style="text-align: right; width: 120px") {{props.item.total | currency}}
                td(style="text-align: right;")
                  v-btn(v-if="!props.item.reference", color="error", text, icon, @click="removeDetail(props.item)")
                    v-icon delete

          v-card-text.mt-3(style="text-align: right")
            div Subtotal: {{invoice.subtotal | currency}}
            div(v-if="invoice.commission")
              div Neto Comisión ({{invoice.commission}}%): {{invoice.commissionSubtotal | currency}}
              div Importe IVA ({{invoice.tax}}%): {{invoice.taxAmount| currency}}
              div Total Comisión: {{invoice.commissionTotal | currency}}
            div(v-else)
              div Importe IVA ({{invoice.tax}}%): {{invoice.taxAmount| currency}}

            h4.display-3.red--text.text-xs-right {{invoice.total | currency}}

          v-card-actions
            v-btn(color="red" dark @click="$router.push('/invoices')") Cancelar
            v-spacer
            v-btn(color="primary", :disabled="!invoice.total", type="submit") Guardar
    v-container(fluid fill-height v-else)
      v-layout(flex align-center justify-center)
        v-progress-circular(indeterminate, color="primary", :size="128", :width="2")
</template>

<style>
.menu__activator a {
  display: inline-flex;
}
</style>

<script>
import { nl2br } from '@/utils/filters';
import validation from '@/utils/validation';

const emptyInvoice = () => {
  const invoice = {
    id: null,
    serie: 'FM',
    company: {
      name: null,
      fiscalName: null,
      vat: null,
      commercialChainName: null,
      commercialChainIdentifier: null,
      accountingAccount: null,
      address: null,
      town: null,
      state: null,
      zip: null,
      country: null,
      phone: null,
      email: null,
    },
    details: [],
    finalCustomer: null,
    reference: null,
    tax: 21,
    commission: 0,
    commissionSubtotal: 0,
    commissionTotal: 0,
    taxAmount: 0,
    subtotal: 0,
    total: 0,
  };
  return invoice;
};

const emptyDetail = () => {
  const detail = {
    reference: null,
    description: null,
    fromDate: null,
    toDate: null,
    price: 0,
    quantity: 1,
    total: 0,
  };
  return detail;
};

export default {
  data() {
    return {
      manualDetailsTableHeaders: [
        {
          text: 'Descripción',
          align: 'left',
          value: 'description',
          sortable: false,
        },
        {
          text: 'Precio',
          align: 'right',
          value: 'price',
          sortable: false,
        },
        {
          text: 'Uds',
          align: 'center',
          value: 'quantity',
          sortable: false,
        },
        {
          text: 'Total',
          align: 'right',
          value: 'total',
          sortable: false,
        },
        {
          text: 'Opciones',
          align: 'right',
          sortable: false,
        },
      ],
      detailsTableHeaders: [
        {
          text: 'Referencia',
          align: 'left',
          value: 'reference',
          sortable: false,
        },
        {
          text: 'Descripción',
          align: 'left',
          value: 'description',
          sortable: false,
        },
        {
          text: 'Desde',
          align: 'left',
          value: 'fromDate',
          sortable: false,
        },
        {
          text: 'Hasta',
          align: 'left',
          value: 'toDate',
          sortable: false,
        },
        {
          text: 'Precio',
          align: 'right',
          value: 'price',
          sortable: false,
        },
        {
          text: 'Uds',
          align: 'center',
          value: 'quantity',
          sortable: false,
        },
        {
          text: 'Total',
          align: 'right',
          value: 'total',
          sortable: false,
        },
        {
          text: 'Opciones',
          align: 'right',
          sortable: false,
        },
      ],
      invoice: {},
      loading: {
        saving: false,
        invoice: false,
        users: false,
        countries: false,
      },
      validation,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    nl2br,
    formatDate(date) {
      if (date) {
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      }
      return date;
    },
    isLoading() {
      return (
        this.loading.saving ||
        this.loading.countries ||
        this.loading.invoice ||
        this.loading.users
      );
    },
    fetchData() {
      this.loading.invoice = true;
      this.loading.users = true;
      this.loading.countries = true;

      if (this.$route.params.id) {
        api
          .get(`/invoices/${this.$route.params.id}`)
          .then((res) => {
            this.invoice = res.data;
          })
          .catch(this.handleError)
          .finally(() => {
            this.loading.invoice = false;
            this.setupUser();
          });
      } else {
        this.invoice = Object.assign({}, emptyInvoice());
        this.loading.invoice = false;
      }

      api
        .get('/users')
        .then((res) => {
          this.users = res.data;
          this.users.map((user) => {
            const u = user;
            if (u.info) {
              if (u.info.commercialName) {
                u.showName = u.info.commercialName;
              } else if (u.info.fiscalName) {
                u.showName = u.info.showName;
              } else {
                u.showName = u.email;
              }
              if (u.info.commercialChain && u.info.commercialChain.name) {
                u.showName += ` - ${u.info.commercialChain.name}`;
              }
            } else {
              u.showName = u.email;
            }
            return u;
          });
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading.users = false;
          this.setupUser();
        });

      api
        .get('/countries')
        .then((res) => {
          this.countries = res.data;
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading.countries = false;
        });
    },
    setupUser() {
      if (this.users && this.users.length > 0 && this.invoice.company.user) {
        this.invoice.company.user = this.users.filter(
          a => a.id === this.invoice.company.user.id,
        )[0];
        this.$forceUpdate();
      }
    },
    updateUserData() {
      const company = this.invoice.company;
      const user = company.user;

      if (user.info.commercialName) {
        company.name = user.info.commercialName;
      } else if (user.info.fiscalName) {
        company.name = user.info.fiscalName;
      } else {
        company.name = `${user.firstName} ${user.lastName}`;
      }

      company.fiscalName = user.info.fiscalName;
      company.vat = user.info.vat;
      company.accountingAccount = user.info.contableAccount;
      company.address = user.info.address;
      company.town = user.info.town;
      company.state = user.info.state;
      company.zip = user.info.zip;
      company.country = user.info.country;
      company.phone = user.info.phone;
      company.email = user.email;
      if (user.info.commercialChain) {
        company.commercialChainName = user.info.commercialChain.name;
      } else {
        company.commercialChainName = null;
      }
      company.commercialChainIdentifier = user.info.commercialChainIdentifier;
      this.invoice.company = company;

      this.invoice.commission = user.info.commission;

      this.$forceUpdate();
    },
    removeDetail(detail) {
      this.invoice.details.splice(this.invoice.details.indexOf(detail), 1);
    },
    addDetail() {
      this.invoice.details.push(emptyDetail());
    },
    handleTaxesChange() {
      this.recalculateTotals();
    },
    handleDetailChange() {
      this.recalculateDetails();
      this.recalculateTotals();
    },
    recalculateDetails() {
      let subtotal = 0;

      this.invoice.details.map((detail) => {
        const newDetail = detail;
        newDetail.total = detail.price * detail.quantity;
        subtotal += newDetail.total;
        return newDetail;
      });

      this.invoice.subtotal = subtotal;
    },
    recalculateTotals() {
      this.recalculateDetails();
      this.invoice.commissionSubtotal = 0;
      this.invoice.commissionTotal = 0;
      this.invoice.taxAmount = 0;
      if (this.invoice.commission) {
        this.invoice.commissionSubtotal =
          this.invoice.subtotal * (this.invoice.commission / 100);
        this.invoice.taxAmount =
          this.invoice.commissionSubtotal * (this.invoice.tax / 100);
        this.invoice.commissionTotal =
          this.invoice.commissionSubtotal + this.invoice.taxAmount;
        this.invoice.total =
          this.invoice.subtotal - this.invoice.commissionTotal;
      } else if (this.invoice.includedTax) {
        this.invoice.taxAmount =
          this.invoice.subtotal - (this.invoice.subtotal / (1 + (this.invoice.tax / 100)));
        this.invoice.total = this.invoice.subtotal;
        this.invoice.subtotal = this.invoice.total - this.invoice.taxAmount;
      } else {
        this.invoice.taxAmount =
          this.invoice.subtotal * (this.invoice.tax / 100);
        this.invoice.total = this.invoice.subtotal + this.invoice.taxAmount;
      }
    },
    handleSubmit() {
      if (
        this.$refs.invoiceForm.validate() &&
        this.invoice.details.length > 0 &&
        this.invoice.total > 0
      ) {
        this.loading.saving = true;
        if (this.invoice.id === null) {
          api
            .post('/invoices', this.invoice)
            .then(() => {
              this.$router.push('/invoices');
            })
            .catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        } else {
          api
            .put(`/invoices/${this.invoice.id}`, this.invoice)
            .then(() => {
              this.$router.push('/invoices');
            })
            .catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Invoices/InvoiceForm.vue